import { Component, h, State } from '@stencil/core';
import { Step } from './types';

@Component({
  tag: 'udp-stepper-demo',
  // styleUrl: 'udp-stepper.css',
  shadow: true,
})
export class UdpStepperDemo {
  @State() activeStep: number = 0;
  @State() completed: { [key: number]: boolean } = {};

  private step1 = (<div>This is step 1 content - Try clicking next!</div>);
  private step2 = (<div>This is step 2 content - You can go back or forward</div>);
  private step3 = (<div>This is step 3 content - Final step!</div>);

  private steps: Step[] = [
    {
      stepDisplay: {
        inProcessIcon: '1',
        completeIcon: '✓',
        title: 'First Step',
        subTitle: 'Start here',
      },
      stepTitle: 'Step 1',
      showTitle: true,
      buttons: [
        {
          title: 'Next',
          action: 2,
          variant: 'default',
          customAction: () => {
            this.completed = { ...this.completed, [0]: true };
            this.activeStep = 1;
          },
        },
      ],
      content: this.step1,
    },
    {
      stepDisplay: {
        inProcessIcon: '2',
        completeIcon: '✓',
        title: 'Second Step',
        subTitle: 'Middle step',
      },
      stepTitle: 'Step 2',
      showTitle: true,
      buttons: [
        {
          title: 'Back',
          action: 1,
          variant: 'outline',
          customAction: () => (this.activeStep = 0),
        },
        {
          title: 'Next',
          action: 3,
          variant: 'default',
          customAction: () => {
            this.completed = { ...this.completed, [1]: true };
            this.activeStep = 2;
          },
        },
      ],
      content: this.step2,
    },
    {
      stepDisplay: {
        inProcessIcon: '3',
        completeIcon: '✓',
        title: 'Final Step',
        subTitle: 'Complete the process',
      },
      stepTitle: 'Step 3',
      showTitle: true,
      buttons: [
        {
          title: 'Back',
          action: 2,
          customAction: () => (this.activeStep = 1),
        },
        {
          title: 'Finish',
          action: 3,
          variant: 'default',
          customAction: () => {
            this.completed = { ...this.completed, [2]: true };
            console.log('Process completed!');
          },
        },
      ],
      content: this.step3,
    },
  ];

  private handleStepChange = (event: number) => {
    this.activeStep = event;
   
  };

  render() {
    return (
      <div style={{ padding: '2rem' }}>
        <unity-typography variant="h2">Horizontal Stepper with Labels bottom</unity-typography>
        <udp-stepper
          steps={this.steps}
          activeStep={this.activeStep}
          completed={this.completed}
          stepChange={this.handleStepChange}
          orientation="horizontal"
          labelDisplay="all"
          labelPosition="bottom"
        />

        <unity-typography variant="h2">Horizontal Stepper without Labels</unity-typography>

        <udp-stepper
          steps={this.steps}
          activeStep={this.activeStep}
          completed={this.completed}
          stepChange={this.handleStepChange}
          orientation="horizontal"
          labelDisplay="none"
          labelPosition="bottom"
        />

        <unity-typography variant="h2">Horizontal Stepper with Labels to Right</unity-typography>
        <udp-stepper
          steps={this.steps}
          activeStep={this.activeStep}
          completed={this.completed}
          stepChange={this.handleStepChange}
          orientation="horizontal"
          labelDisplay="all"
          labelPosition="right"
        />

        <unity-typography variant="h2">Vertical Stepper</unity-typography>
        <udp-stepper
          steps={this.steps}
          activeStep={this.activeStep}
          completed={this.completed}
          stepChange={this.handleStepChange}
          orientation="vertical"
          labelDisplay="all"
          labelPosition="right"
        />
      </div>
    );
  }
}
